import React from "react";
import { LockOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { Divider, Typography } from "antd";
import GradientButton from "../../../../common/UI/GradientButton";
import { formatCurrency } from "../../../../../utils/currency";
import ORDER_REVIEW from "../constants";
import { OrderTotals } from "../types";

const { Title } = Typography;

interface OrderSummaryProps {
  totals: OrderTotals;
  currency: string;
  hasPaymentCard: boolean;
  submitting: boolean;
  onConfirm: () => void;
}

const SUMMARY_ROWS: Array<{
  key: keyof Pick<OrderTotals, "price" | "shippingCharge" | "activationCharge">;
  label: string;
}> = [
  { key: "price", label: ORDER_REVIEW.LABELS.PRICE },
  { key: "shippingCharge", label: ORDER_REVIEW.LABELS.SHIPPING_CHARGE },
  { key: "activationCharge", label: ORDER_REVIEW.LABELS.ACTIVATION_CHARGE },
];

const OrderSummary: React.FC<OrderSummaryProps> = ({
  totals,
  currency,
  hasPaymentCard,
  submitting,
  onConfirm,
}) => (
  <div className="or-summary-card">
    <Title level={4} className="or-summary-title">
      {ORDER_REVIEW.LABELS.ORDER_SUMMARY}
    </Title>

    <div className="or-summary-rows">
      {SUMMARY_ROWS.map(({ key, label }) => (
        <div key={key} className="or-summary-row">
          <span>{label}</span>
          <span>{formatCurrency(totals[key], currency)}</span>
        </div>
      ))}
    </div>

    <Divider className="or-divider" />

    <div className="or-total-row">
      <span>{ORDER_REVIEW.LABELS.TOTAL_DUE}</span>
      <span className="or-total-price">
        {formatCurrency(totals.total, currency)}
      </span>
    </div>

    <GradientButton
      size="large"
      icon={<LockOutlined />}
      disabled={!hasPaymentCard || submitting}
      loading={submitting}
      onClick={onConfirm}
      className="or-confirm-btn"
    >
      {ORDER_REVIEW.LABELS.CONFIRM}
    </GradientButton>

    <div className="or-ssl">
      <SafetyCertificateOutlined />
      <span>{ORDER_REVIEW.SSL_LABEL}</span>
    </div>
  </div>
);

export default OrderSummary;
